import {
  Box,
  Checkbox,
  Fade,
  List,
  ListItem,
  makeStyles,
  Paper,
  Popover,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Tooltip,
  Typography,
  useTheme,
  useMediaQuery
} from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import { Pagination } from '@material-ui/lab';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import { useLocation, useNavigate } from 'react-router-dom';
import ModalConfirm from 'src/app/components/ModalConfirm';
import { DEVICE_STATUS, PAGE_SIZE_LIST } from 'src/app/constant/config';
import { MESSAGE } from 'src/app/constant/message';
import { closeDialogConfirm, showDialogConfirm } from 'src/features/uiSlice';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { useDispatch, useSelector } from 'react-redux';
import DialogConfirm from 'src/app/components/DialogConfirm';
import LoadingComponent from 'src/app/components/Loading';
import {
  controlSoundWarning,
  deleteDevices,
  postExtendDevice,
  recallDevices,
  recallDevicesByAgency,
  returnDeviceToStock,
  updateDeviceDisplayName,
} from 'src/features/deviceSlice';
import ActiveDevice from './ActiveDevice';
import EditDevice from './EditDevice';
import './style.css';
import TransferDevice from './TransferDevice';
import EditVersion from './EditVersion';
import { CustomSwitchWithText } from './EditVersion/components/common';
import ExtendDevice from './ExtendDevice';
import TransferSeller from './TransferSeller';
import AddDisplayName from './AddDisplayName';
import ChangeLicensePlate from './ChangeLicensePlate';
import { buttonPermissions, menuPermissions } from './constance';
import { getDetailVehicle } from 'src/features/vehicleSlice';
import { getRemainingDays, getTransmissionStatusText } from 'src/app/utils/commomService';
import ExtendService from './ExtendService';
import BulkExtendModal from './BulkExtendModal';
import WarrantyReplacementModal from './WarrantyReplacementModal';
import { useDragScroll } from 'src/app/hooks/useDragScroll';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const truncateText = (text, maxLength = 30) => {
  if (!text || text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
};

const copyTextToClipboard = async text => {
  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (err) {
      // Fallback xuống execCommand nếu quyền bị từ chối
    }
  }

  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'fixed';
  textarea.style.top = '-9999px';
  document.body.appendChild(textarea);
  textarea.select();

  let success = false;
  try {
    success = document.execCommand('copy');
  } catch (err) {
    success = false;
  }
  document.body.removeChild(textarea);
  return success;
};

const CopyableText = ({ value, label, onCopied, classes }) => {
  const text = value == null || value === '' ? '' : String(value);
  if (!text) return '--';

  const handleCopy = event => {
    event.preventDefault();
    event.stopPropagation();
    copyTextToClipboard(text).then(() => {
      if (onCopied) onCopied(label);
    });
  };

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center' }}>
      <span>{text}</span>
      <Tooltip title={`Copy ${label}`}>
        <FileCopyOutlinedIcon
          className={classes.copyIcon}
          onClick={handleCopy}
        />
      </Tooltip>
    </span>
  );
};

const CAMERA_DEVICE_TYPES = ['VGPS_2CAM', 'VGPS_4CAM'];
const isLive4gOn = device => Number(device?.is_allow_camera) === 2;

const DEVICE_TABLE_HEAD_CELLS = [
  {
    id: 'index',
    label: 'STT',
    style: { width: 50, minWidth: 50, textAlign: 'center' },
    sortable: false
  },
  {
    id: 'license_plate',
    label: 'Biển số',
    style: { width: 120, minWidth: 120 },
    sortable: false
  },
  {
    id: 'name',
    label: 'Tên gợi nhớ',
    style: { width: 120, minWidth: 120 },
    sortable: false
  },
  {
    id: 'vehicle_type',
    label: 'Loại phương tiện',
    style: { width: 130, minWidth: 130 },
    sortable: false
  },
  {
    id: 'device_type',
    label: 'Loại thiết bị',
    style: { width: 120, minWidth: 120 },
    sortable: false
  },
  {
    id: 'serial',
    label: 'Serial',
    style: { width: 150, minWidth: 150 },
    sortable: false
  },
  {
    id: 'network_operator',
    label: 'Nhà mạng',
    style: { width: 120, minWidth: 120 }
  },
  {
    id: 'imei',
    label: 'Imei sim',
    style: { width: 100, minWidth: 180 },
    sortable: false
  },
  {
    id: 'hardware_version',
    label: 'Phiên bản HW',
    style: { width: 130, minWidth: 130 }
  },
  {
    id: 'firmware_version',
    label: 'Phiên bản FW',
    style: { width: 130, minWidth: 130 }
  },
  {
    id: 'status',
    label: 'Trạng thái',
    style: { width: 100, minWidth: 100 }
  },
  {
    // id = sort_field gửi lên API (sắp xếp phía server)
    id: 'is_allow_camera',
    label: 'Live 4G',
    style: { width: 100, minWidth: 100, textAlign: 'center' }
  },
  {
    id: 'active_at',
    label: 'Ngày kích hoạt',
    style: { width: 150, minWidth: 150 }
  },
  {
    id: 'service_package',
    label: 'Dịch vụ',
    style: { width: 150, minWidth: 150 }
  },
  {
    id: 'acc_status',
    label: 'ACC MODE',
    style: { width: 50, minWidth: 50 }
  },
  {
    id: 'battery',
    label: 'Điện áp',
    style: { width: 100, minWidth: 100 }
  },
  {
    id: 'slots_or_tonnage',
    label: 'Số chỗ/Tải trọng',
    style: { width: 150, minWidth: 150 }
  },
  {
    id: 'oil_status',
    label: 'CBNL',
    style: { width: 50, minWidth: 50 }
  },
  {
    id: 'status_transmission',
    label: 'Tích truyền',
    style: { width: 120, minWidth: 120, textAlign: 'center' }
  },

  {
    id: 'remaining_days',
    label: 'Số ngày còn lại',
    style: { width: 140, minWidth: 140 }
  },
  {
    id: 'extend_package',
    label: 'Gói dịch vụ gia hạn',
    style: { width: 160, minWidth: 160 }
  },
  {
    id: 'date_of_manufacture',
    label: 'Ngày sản xuất',
    style: { width: 140, minWidth: 140 }
  },
  {
    id: 'end_user_name',
    label: 'Người dùng',
    style: { width: 150, minWidth: 150 },
    sortable: false
  },
  {
    id: 'end_user_phone',
    label: 'Số điện thoại',
    style: { width: 120, minWidth: 120 },
    sortable: false
  },
  {
    id: 'agency_name',
    label: 'Đại lý',
    style: { width: 150, minWidth: 150 },
    sortable: false
  }
];

// Các cột sắp xếp phía server (gọi API với sort_field/sort_order)
const SERVER_SORT_FIELDS = [
  'firmware_version',
  'hardware_version',
  'date_of_manufacture',
  'active_at',
  'network_operator',
  'acc_status',
  'is_allow_camera',
  'oil_status'
];

const getDeviceStatusRank = device => {
  if (device?.status === DEVICE_STATUS.ACTIVE) {
    return device?.deviceServicePackages?.remaining_days > 0 ? 2 : 1;
  }

  if (device?.status === DEVICE_STATUS.INACTIVE) {
    return 0;
  }

  return -1;
};

const getRemainingDaysSortValue = endDate => {
  if (!endDate) return -1;

  const now = moment();
  const expiration = moment(endDate);
  if (!expiration.isValid()) return -1;

  return expiration.diff(now, 'seconds');
};

const getSlotsOrTonnageSortValue = device => {
  const vehicleType = device?.vehicle?.vehicle_type?.title;

  if (vehicleType === 'Xe khách') {
    return Number(device?.vehicle?.vehicle_type?.slots) || 0;
  }

  if (vehicleType === 'Xe tải') {
    return Number(device?.vehicle?.vehicle_type?.tonnage) || 0;
  }

  return 0;
};

const getAccStatusText = device => {
  const accStatus = device?.acc_status ?? device.deviceAcc?.acc_status;

  if (accStatus === undefined || accStatus === null) return '--';
  return accStatus ? 'Bật' : 'Tắt';
};

const OIL_SENSOR_DEVICE_TYPES = ['VGPS_CAR4G', ...CAMERA_DEVICE_TYPES];

const getOilStatusText = device => {
  if (!OIL_SENSOR_DEVICE_TYPES.includes(device?.deviceType?.name)) return '--';

  const oilStatus = device?.oil_status;
  if (oilStatus === undefined || oilStatus === null) return '--';
  return Number(oilStatus) === 0 ? 'Tắt' : 'Bật';
};

const getDeviceSortValue = (device, field) => {
  switch (field) {
    case 'license_plate':
      return device?.vehicle?.license_plate || '';
    case 'name':
      return device?.name || '';
    case 'vehicle_type':
      return device?.vehicle?.vehicle_type?.title || '';
    case 'acc_status':
      return getAccStatusText(device);
    case 'battery':
      return device?.battery || 0;
    case 'slots_or_tonnage':
      return getSlotsOrTonnageSortValue(device);
    case 'status_transmission':
      return Number(device?.status_transmission ?? 0);
    case 'device_type':
      return device?.deviceType?.name || '';
    case 'serial':
      return device?.serial || '';
    case 'network_operator':
      return device?.network_operator || '';
    case 'imei':
      return device?.imei || '';
    case 'hardware_version':
      return device?.hardware_version || '';
    case 'firmware_version':
      return device?.firmware_version || '';
    case 'status':
      return getDeviceStatusRank(device);
    case 'active_at':
      return device?.active_at ? moment(device.active_at).valueOf() : 0;
    case 'service_package':
      return device?.deviceServicePackages?.servicePackage?.name || '';
    case 'remaining_days':
      return getRemainingDaysSortValue(device?.subscription?.end);
    case 'extend_package':
      return device?.servicePackageExtend?.[0]?.servicePackage?.name || '';
    case 'date_of_manufacture':
      return device?.date_of_manufacture
        ? moment(device.date_of_manufacture).valueOf()
        : 0;
    case 'end_user_name':
      return device?.end_user?.user?.full_name || '';
    case 'end_user_phone':
      return device?.end_user?.user?.phone || '';
    case 'agency_name':
      return `${device?.agency?.name || ''} ${device?.agency?.agency_code || ''}`.trim();
    default:
      return '';
  }
};

const compareSortValues = (leftValue, rightValue) => {
  const isLeftNumber = typeof leftValue === 'number';
  const isRightNumber = typeof rightValue === 'number';

  if (isLeftNumber && isRightNumber) {
    if (leftValue < rightValue) return -1;
    if (leftValue > rightValue) return 1;
    return 0;
  }

  return String(leftValue).localeCompare(String(rightValue), 'vi', {
    numeric: true,
    sensitivity: 'base'
  });
};

const RenderListExtendPackages = ({ listPackages, classes }) => {
  const [anchorElRow, setAnchorElRow] = useState(null);

  const handlePopoverOpen = event => {
    setAnchorElRow(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorElRow(null);
  };

  const open = Boolean(anchorElRow);
  return (
    <div>
      <Typography
        aria-owns={open ? 'mouse-over-popover' : undefined}
        aria-haspopup="true"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
        style={{ fontSize: '14px' }}
      >
        {listPackages[0]?.servicePackage?.name || '--'}
      </Typography>
      {listPackages?.length > 0 && (
        <Popover
          id="mouse-over-popover"
          className={classes.popover}
          classes={{
            paper: classes.paper
          }}
          open={open}
          anchorEl={anchorElRow}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left'
          }}
          onClose={handlePopoverClose}
          disableRestoreFocus
        >
          {listPackages?.map((item, index) => {
            return (
              <Typography
                key={index}
                style={{ fontSize: '14px', lineHeight: '2' }}
              >
                {item?.servicePackage?.name}
              </Typography>
            );
          })}
        </Popover>
      )}
    </div>
  );
};

const Results = ({
  isLoading,
  getListDeviceRef,
  totalDevice,
  listDevice,
  currentParams
}) => {
  const query = useQuery();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const classes = useStyles();
  const dragScrollRef = useDragScroll();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [limit, setLimit] = useState(PAGE_SIZE_LIST);
  const [page, setPage] = useState(1);
  const [order, setOrder] = useState(currentParams?.sort_order || 'asc');
  const [orderBy, setOrderBy] = useState(
    currentParams?.sort_field || 'status_transmission'
  );
  const [rowsSelected, setRowsSelected] = useState([]);
  const [mixedTypeWarning, setMixedTypeWarning] = useState(false);
  const [selectedDeviceType, setSelectedDeviceType] = useState(null); // loại thiết bị đang được chọn hàng loạt
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openEditVersionModal, setOpenEditVersionModal] = useState(false);
  const [openTransferModal, setOpenTransferModal] = useState(false);
  const [openRecallModal, setOpenRecallModal] = useState(false);
  const [openExtendModal, setOpenExtendModal] = useState(false);
  const [openModalActive, setOpenModalActive] = useState(false);
  const [openModalSeller, setOpenModalSeller] = useState(false);
  const [openModalSettingSound, setOpenModalSettingSound] = useState(false);
  const [openDisplayNameModal, setOpenDisplayNameModal] = useState(false);
  const [openSwapLicensePlateModal, setOpenSwapLicensePlateModal] = useState(
    false
  );
  const [
    openChangeLicensePlateModal,
    setOpenChangeLicensePlateModal
  ] = useState(false);
  const [openExtendServiceModal, setOpenExtendServiceModal] = useState(false);
  const [openBulkExtendModal, setOpenBulkExtendModal] = useState(false);
  const [
    openWarrantyReplacementModal,
    setOpenWarrantyReplacementModal
  ] = useState(false);
  const [openWarrantyModal, setOpenWarrantyModal] = useState(false);
  const [warrantyDevice, setWarrantyDevice] = useState(null);
  const [devicesToExtend, setDevicesToExtend] = useState([]);
  // Lưu cả object device để giữ dữ liệu khi chuyển giữa các trang
  const [selectedDevicesMap, setSelectedDevicesMap] = useState({});

  const [itemCurrent, setItemCurrent] = useState({});
  const [confirmType, setConfirmType] = useState('delete');
  const [dataChecked, setDataChecked] = useState({});
  const [editOnBar, setEditOnBar] = useState(true);

  // Menu action right

  const ACTION_LABELS = {
    ACTIVATE: 'Kích hoạt thiết bị',
    SELECT_PACKAGE: 'Chọn gói dịch vụ gia hạn',
    EDIT_DEVICE: 'Cấu hình thiết bị',
    TRANSFER_AGENT: 'Chuyển xuống đại lý',
    EXTEND: 'Gia hạn thiết bị',
    RECALL: 'Thu hồi thiết bị bảo hành',
    SELECT_SELLER: 'Chọn người bán',
    ADD_DISPLAY_NAME: 'Thêm tên gợi nhớ',
    SWAP_LICENSE_PLATE: 'Dùng tên/biển số',
    CONTROL_ALERT: 'Cài đặt âm thanh cảnh báo',
    DELETE: 'Xóa',
    CHANGE_LICENSE_PLATE: 'Đổi biển số phương tiện',
    EXTEND_SERVICE: 'Gia hạn dịch vụ',
    GOTO_MAP: 'Tới vị trí trên bản đồ',
    RETURN_TO_STOCK: 'Chuyển về lưu kho',
    WARRANTY_REPLACEMENT: 'Đổi thiết bị bảo hành'
  };

  const handleWarrantyReplacement = device => {
    setWarrantyDevice(device || itemCurrent);
    setOpenWarrantyModal(true);
    handleCloseMenu();
  };

  const renderMenu = (role, device) => {
    const menuActions = {
      ACTIVATE: () => handleActiveDevice(),
      SELECT_PACKAGE: () => handleEditDevice(),
      EDIT_DEVICE: () => handleEditVersion(),
      TRANSFER_AGENT: () => handleTransferDevice(device.id),
      EXTEND: () => handleExtendDevice(device),
      RECALL: () => handleRecallDevice(),
      SELECT_SELLER: () => handleTransferSeller(),
      ADD_DISPLAY_NAME: () => handleAddDisplayName(),
      SWAP_LICENSE_PLATE: () => handleSwapLicensePlate(),
      CONTROL_ALERT: () => handleSettingSoundWarn(),
      DELETE: () => handleDeleteDevice(device.id),
      CHANGE_LICENSE_PLATE: () => handleChangeLicensePlate(),
      EXTEND_SERVICE: () => handleExtendService(),
      GOTO_MAP: () => handleGoToMap(device),
      RETURN_TO_STOCK: () => handleReturnToStock(),
      WARRANTY_REPLACEMENT: () => handleWarrantyReplacement(device)
    };

    const getFilteredActions = (role, device) => {
      // Get define the base actions based on the role
      const baseActions = [...(menuPermissions[role] || [])];
      // Đại lý được admin cấp quyền is_allow_swap thì có thêm "Thay thế thiết bị bảo hành"
      if (role === 'agency' && allowSwap && !baseActions.includes('WARRANTY_REPLACEMENT')) {
        baseActions.push('WARRANTY_REPLACEMENT');
      }
      let status = device.status;

      const isExistPackage =
        device?.deviceServicePackages?.length !== 0 ? true : false;
      const isOutDate =
        status === 'active' &&
        device &&
        device?.deviceServicePackages?.remaining_days < 1;
      if (isExistPackage && status === 'inactive') {
        status = 'inactive_has_package';
      }

      if (isOutDate) {
        status = 'out_date';
      }

      const excludedByStatus = {
        active: ['ACTIVATE', 'TRANSFER_AGENT', 'SELECT_SELLER', 'DELETE', 'RETURN_TO_STOCK'],
        inactive: [
          'EXTEND',
          'RECALL',
          'ADD_DISPLAY_NAME',
          'SWAP_LICENSE_PLATE',
          'CONTROL_ALERT',
          'CHANGE_LICENSE_PLATE',
          'EXTEND_SERVICE',
          'GOTO_MAP',
          'WARRANTY_REPLACEMENT',
          'EDIT_DEVICE',
          'RETURN_TO_STOCK'
        ],
        inactive_has_package: [
          'RETURN_TO_STOCK',
          'EXTEND',
          'RECALL',
          'ADD_DISPLAY_NAME',
          'SWAP_LICENSE_PLATE',
          'CHANGE_LICENSE_PLATE',
          'EXTEND_SERVICE',
          'GOTO_MAP',
          'EDIT_DEVICE'
        ],
        out_date: [
          'ACTIVATE',
          'TRANSFER_AGENT',
          'SELECT_SELLER',
          'DELETE',
          'EDIT_DEVICE',
          'CONTROL_ALERT',
          'CHANGE_LICENSE_PLATE',
          'RETURN_TO_STOCK'
        ],
        warranty: ['ACTIVATE', 'RECALL', 'TRANSFER_AGENT', 'SELECT_SELLER', 'DELETE', 'GOTO_MAP', 'SELECT_PACKAGE', 'EXTEND', 'EXTEND_SERVICE']
      };

      const isUsingDisplayName = Boolean(device?.is_display_name);
      const excluded = excludedByStatus[status] || [];

      return baseActions.filter(action => {
        if (isUsingDisplayName && action === 'ADD_DISPLAY_NAME') {
          return false;
        }

        if (!isUsingDisplayName && action === 'SWAP_LICENSE_PLATE') {
          return false;
        }

        // Chỉ admin (hoặc đại lý có quyền is_allow_swap), thiết bị đang hoạt động mới được thay thế bảo hành
        const canWarrantyReplace =
          role === 'admin' || (role === 'agency' && allowSwap);
        if (
          action === 'WARRANTY_REPLACEMENT' &&
          (!canWarrantyReplace || device?.status !== DEVICE_STATUS.ACTIVE)
        ) {
          return false;
        }

        if (
          action === 'CONTROL_ALERT' &&
          device?.deviceType?.name !== 'VGPS_CAR4G'
        ) {
          return false;
        }

        return !excluded.includes(action);
      });
    };

    const allowedActions = getFilteredActions(role, device);

    return (
      <Typography component="div">
        <List disablePadding>
          {allowedActions.map((item, index) => {
            const onClickHandler = menuActions[item];
            const isLastItem = index === allowedActions.length - 1;
            if (!onClickHandler) return null;

            return (
              <ListItem
                key={item}
                onClick={onClickHandler}
                className={`list-menu-device cursor-pointer${isLastItem ? '' : ' border-bottom'}`}
              >
                {item === 'DELETE' ? (
                  <span className="text-danger">{ACTION_LABELS[item]}</span>
                ) : (
                  ACTION_LABELS[item]
                )}
              </ListItem>
            );
          })}
        </List>
      </Typography>
    );
  };

  // Menu action header bar
  const renderButtons = (role, row) => {
    const selectedList = rowsSelected.length > 0 ? Object.values(selectedDevicesMap) : (row ? [row] : []);

    // Kiểm tra tất cả thiết bị được chọn có cùng trạng thái active hoặc inactive không
    const isAllActive = selectedList.length > 0 && selectedList.every(d => d.status === 'active');
    const isAllInactive = selectedList.length > 0 && selectedList.every(d => d.status === 'inactive');

    let buttonConfig = [
      {
        id: 7,
        label: 'Chọn gói dịch vụ gia hạn',
        onClick: () => setOpenEditModal(true),
        icon: '/static/iconSvg/dollar.svg',
        alt: 'select service package'
      },
      {
        id: 8,
        label: 'Gia hạn dịch vụ',
        onClick: () => {
          setDevicesToExtend(selectedList);
          setOpenExtendServiceModal(true);
        },
        icon: '/static/iconSvg/dollar.svg',
        alt: 'extend service'
      },
      {
        id: 2,
        label: 'Chọn người bán',
        onClick: () => setOpenModalSeller(true),
        icon: '/static/iconSvg/select-seller.svg',
        alt: 'seller'
      },
      {
        id: 3,
        label: 'Kích hoạt',
        onClick: () => setOpenModalActive(true),
        icon: '/static/iconSvg/car.svg',
        alt: 'seller'
      },
      {
        id: 4,
        label: 'Thu hồi',
        onClick: () => setOpenRecallModal(true),
        icon: '/static/iconSvg/recall.svg',
        alt: 'seller'
      },
      {
        id: 5,
        label: 'Chuyển xuống đại lý',
        onClick: () => setOpenTransferModal(true),
        icon: '/static/iconSvg/transfer.svg',
        alt: 'seller'
      },
      {
        id: 6,
        label: 'Xóa',
        onClick: () => handleDeleteMultiDevices(),
        icon: '/static/iconSvg/delete-icon.svg',
        alt: 'delete'
      }
    ];

    // Chỉ giữ các nút dùng CHUNG cho TẤT CẢ thiết bị được chọn (nếu chọn hỗn hợp thì chỉ giữ nút áp dụng cho cả 2 như Chọn gói gia hạn & Xóa)
    buttonConfig = buttonConfig.filter(btn => {
      // 8 (Gia hạn dịch vụ) & 4 (Thu hồi): Chỉ hiện khi TẤT CẢ thiết bị chọn đều là Kích hoạt (isAllActive)
      if ([4, 8].includes(btn.id) && !isAllActive) return false;
      // 3 (Kích hoạt), 5 (Chuyển xuống đại lý), 2 (Chọn người bán): Chỉ hiện khi TẤT CẢ thiết bị chọn đều là Lưu kho (isAllInactive)
      if ([2, 3, 5].includes(btn.id) && !isAllInactive) return false;
      return true;
    });

    const allowedButtons = buttonPermissions[role] || [];
    const filteredButtons = buttonConfig.filter(btn =>
      allowedButtons.includes(btn.label)
    );

    return (
      <>
        {filteredButtons.map((btn, index) => (
          <span
            key={index}
            onClick={btn.onClick}
            className="mx-2 btnDevice"
            color="primary"
            variant="outlined"
            size="small"
          >
            <img
              src={btn.icon}
              alt={btn.alt}
              style={{ paddingRight: '5px', paddingBottom: '4px' }}
            />
            <span className="pt-1">{btn.label}</span>
          </span>
        ))}
      </>
    );
  };

  const DeviceMenu = ({ role, device }) => {
    return renderMenu(role, device);
  };

  const DeviceButtons = ({ role, row }) => {
    return renderButtons(role, row);
  };

  const dataLogin = useSelector(state => state.authSlice.dataLogin);
  const role = dataLogin?.role?.title;
  const isAdmin = useSelector(state => state.authSlice.isAdmin);
  const isAgency = useSelector(state => state.authSlice.isAgency);
  const isAccountant = useSelector(state => state.authSlice.isAccountant);
  const isSale = useSelector(state => state.authSlice.isSale);
  const isCustomerCare = useSelector(state => state.authSlice.isCustomerCare);
  const agencyId = useSelector(state => state.authSlice.agencyId);
  const allowSwap = useSelector(state => state.authSlice.allowSwap);

  const [params, setParams] = useState({
    ...currentParams,
    page: currentParams?.page || page,
    page_size: currentParams?.page_size || limit
  });

  useEffect(() => {
    if (currentParams) {
      setParams({
        ...currentParams,
        page: currentParams?.page || 1,
        page_size: currentParams?.page_size || PAGE_SIZE_LIST
      });
    }
  }, [currentParams]);

  useEffect(() => {
    const pageFromQuery = query.get('page');
    const pageSizeFromQuery = query.get('page_size');

    if (pageFromQuery) {
      setPage(Number(pageFromQuery));
    }
    if (pageSizeFromQuery) {
      setLimit(Number(pageSizeFromQuery));
    }
  }, [query]);

  useEffect(() => {
    if (rowsSelected.length === 0) {
      if (selectedDeviceType !== null) setSelectedDeviceType(null);
      if (Object.keys(selectedDevicesMap).length > 0) setSelectedDevicesMap({});
      setDataChecked({});
    }
  }, [rowsSelected]);

  const [anchorEl, setAnchorEl] = useState(null);
  const [copyToast, setCopyToast] = useState('');
  const rowMouseDownRef = useRef(null);

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const handleCopied = label => {
    setCopyToast(`Đã copy ${label}`);
  };

  const handleRowClick = (event, device) => {
    const start = rowMouseDownRef.current;
    if (start) {
      const dragged =
        Math.abs(event.clientX - start.x) > 5 ||
        Math.abs(event.clientY - start.y) > 5;
      if (dragged) return;
    }

    const selection = window.getSelection();
    if (selection && selection.toString().trim()) return;

    handleClickMenu(event, device);
  };
  const dataSelected = editOnBar ? dataChecked : itemCurrent;

  const checked = id => {
    return rowsSelected.indexOf(id) !== -1;
  };

  const getDeviceTypeName = (device) =>
    device?.deviceType?.name ||
    device?.device_type_name ||
    (typeof device?.device_type === 'string' ? device.device_type : null);

  const select = (deviceId, device) => {
    let rowIndex = rowsSelected.indexOf(deviceId);
    setEditOnBar(true);
    if (rowIndex === -1) {
      // Kiểm tra loại thiết bị có khớp với loại đang được chọn không
      if (rowsSelected.length > 0) {
        const thisType = getDeviceTypeName(device);
        if (selectedDeviceType && thisType && selectedDeviceType !== thisType) {
          setMixedTypeWarning(true);
          return;
        }
      }
      const newSelected = [deviceId, ...rowsSelected];
      setRowsSelected(newSelected);
      // Lưu device object vào map
      const newMap = { ...selectedDevicesMap, [deviceId]: device };
      setSelectedDevicesMap(newMap);
      setDataChecked(device);
      // Lưu loại thiết bị khi chọn thiết bị đầu tiên
      if (rowsSelected.length === 0) {
        setSelectedDeviceType(getDeviceTypeName(device));
      }
    } else {
      const newSelected = rowsSelected.filter(i => i !== deviceId);
      setRowsSelected(newSelected);
      // Xóa khỏi map
      const newMap = { ...selectedDevicesMap };
      delete newMap[deviceId];
      setSelectedDevicesMap(newMap);

      // Cập nhật lại dataChecked khi bỏ chọn:
      if (newSelected.length === 0) {
        setSelectedDeviceType(null);
        setDataChecked({});
      } else {
        const lastSelectedId = newSelected[0];
        if (newMap[lastSelectedId]) {
          setDataChecked(newMap[lastSelectedId]);
        }
      }
    }
  };

  const handleDeleteMultiDevices = () => {
    setConfirmType('delete');
    dispatch(showDialogConfirm());
  };

  const confirmDeleteDevices = () => {
    const listId = rowsSelected.length > 0 ? rowsSelected : [itemCurrent.id];
    dispatch(closeDialogConfirm());
    dispatch(deleteDevices({ list_device_ids: listId }));
    setRowsSelected([]);
  };

  const handleDeleteDevice = () => {
    setConfirmType('delete');
    dispatch(showDialogConfirm());
    handleCloseMenu();
  };

  const handleReturnToStock = () => {
    setConfirmType('return_to_stock');
    dispatch(showDialogConfirm());
    handleCloseMenu();
  };

  const confirmReturnToStock = () => {
    const deviceId = itemCurrent.id;
    dispatch(closeDialogConfirm());
    dispatch(
      returnDeviceToStock({ id: deviceId, data: { status: DEVICE_STATUS.INACTIVE } })
    ).then(action => {
      if (!action.error && getListDeviceRef) getListDeviceRef(params);
    });
    setRowsSelected([]);
    setItemCurrent({});
  };

  const handleRecallDevice = () => {
    setOpenRecallModal(true);
    handleCloseMenu();
  };

  const handleSettingSoundWarn = () => {
    setOpenModalSettingSound(true);
    handleCloseMenu();
  };

  const handleChangeLicensePlate = () => {
    setOpenChangeLicensePlateModal(true);
    handleCloseMenu();
  };

  const handleExtendService = () => {
    setOpenExtendServiceModal(true);
    handleCloseMenu();
  };

  const handleGoToMap = device => {
    handleCloseMenu();

    const params = new URLSearchParams();

    // Đại lý sở hữu thiết bị
    const deviceAgencyId =
      device?.agency?.id || device?.agency_id || device?.owner_id;
    // Tài khoản (end user) sở hữu thiết bị
    const deviceEndUserId =
      device?.end_user?.id ||
      device?.end_user_id ||
      device?.end_user?.user?.id;

    if (deviceAgencyId) params.set('agency_id', deviceAgencyId);
    if (deviceEndUserId) params.set('end_user_id', deviceEndUserId);

    // Biển số dùng để auto chọn (focus) phương tiện trên bản đồ
    const licensePlate =
      device?.vehicle?.license_plate || device?.license_plate || '';
    if (licensePlate) params.set('license_plate', licensePlate);

    const search = params.toString();
    navigate(search ? `/app/tracking?${search}` : '/app/tracking');
  };

  const confirmSettingSoundWarn = () => {
    const deviceId = itemCurrent.id;
    const controlSoundReq = itemCurrent?.is_turn_on_sound ? 1 : 0;
    dispatch(
      controlSoundWarning({ id: deviceId, data: { status: controlSoundReq } })
    );
    dispatch(closeDialogConfirm());
    setOpenModalSettingSound(false);
    setRowsSelected([]);
  };

  const confirmExtendDevices = () => {
    const deviceId = itemCurrent.id;
    dispatch(closeDialogConfirm());
    dispatch(postExtendDevice({ id: deviceId, data: {} }));
    setOpenExtendModal(false);
    setRowsSelected([]);
  };

  const handleAddDisplayName = () => {
    setOpenDisplayNameModal(true);
    handleCloseMenu();
  };

  const handleSwapLicensePlate = () => {
    setOpenSwapLicensePlateModal(true);
    handleCloseMenu();
  };

  const handleTransferSeller = () => {
    setOpenModalSeller(true);
    handleCloseMenu();
  };

  const getStatusDevice = (status, remainingDays) => {
    switch (status) {
      case DEVICE_STATUS.ACTIVE:
        return (
          <span
            className="badge-actived badge"
            style={{
              backgroundColor: remainingDays > 0 ? '#d4efdf' : '#F8D7DA',
              color: remainingDays > 0 ? '#3DB670' : '#D9534F'
            }}
          >
            {remainingDays > 0 ? 'Kích hoạt' : 'Hết hạn'}
          </span>
        );
      case DEVICE_STATUS.INACTIVE:
        return (
          <span
            className="badge-inActived badge"
            style={{
              backgroundColor: '#E7E8EE',
              color: '#475461'
            }}
          >
            Lưu kho
          </span>
        );
      case DEVICE_STATUS.WARRANTY:
        return (
          <span
            className="badge-actived badge"
            style={{
              backgroundColor: '#FFF1DC',
              color: '#D9822B'
            }}
          >
            Bảo hành
          </span>
        );
      default:
        return '-';
    }
  };

  const getSlotsOrTonnage = (vehicleType, device) => {
    switch (vehicleType) {
      case 'Xe khách':
        return <span> {device.vehicle?.vehicle_type?.slots} chỗ </span>;
      case 'Xe tải':
        return <span> {device.vehicle?.vehicle_type?.tonnage}</span>;
      default:
        return '--';
    }
  };

  // Serial các thiết bị sẽ thu hồi (chọn nhiều hoặc thiết bị đang mở menu)
  const recallSerialText = (rowsSelected.length > 0
    ? rowsSelected.map(id => selectedDevicesMap[id]?.serial)
    : [itemCurrent?.serial]
  )
    .filter(Boolean)
    .map(serial => `"${serial}"`)
    .join(', ');

  const confirmRecall = () => {
    const listId = rowsSelected.length > 0 ? rowsSelected : [itemCurrent.id];
    if (isAdmin) {
      dispatch(recallDevices({ list_device_id: listId }));
    } else if (isAgency) {
      dispatch(
        recallDevicesByAgency({
          id: agencyId,
          data: { list_device_id: listId }
        })
      );
    }
    setRowsSelected([]);
    setOpenRecallModal(false);
  };

  const confirmSwap = async () => {
    await dispatch(
      updateDeviceDisplayName({
        id: itemCurrent.id,
        data: {
          enable: false
        }
      })
    );
    setOpenSwapLicensePlateModal(false);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
    if (!getListDeviceRef) return;
    const newparams = {
      ...currentParams,
      page: newPage,
      page_size: isMobile ? 6 : limit
    };
    setParams(newparams);
    getListDeviceRef(newparams);
  };

  const handleRequestSort = property => {
    const isAsc = orderBy === property && order === 'asc';
    const newOrder = isAsc ? 'desc' : 'asc';
    setOrder(newOrder);
    setOrderBy(property);

    if (!getListDeviceRef) return;
    if (SERVER_SORT_FIELDS.includes(property)) {
      getListDeviceRef({
        sort_field: property,
        sort_order: newOrder,
        page: 1
      });
    } else if (currentParams?.sort_field) {
      getListDeviceRef({ sort_field: undefined, sort_order: undefined });
    }
  };

  const sortedDevices = useMemo(() => {
    if (!Array.isArray(listDevice)) return [];
    if (SERVER_SORT_FIELDS.includes(orderBy)) return listDevice;

    return [...listDevice].sort((leftDevice, rightDevice) => {
      const leftValue = getDeviceSortValue(leftDevice, orderBy);
      const rightValue = getDeviceSortValue(rightDevice, orderBy);
      const comparison = compareSortValues(leftValue, rightValue);

      return order === 'asc' ? comparison : -comparison;
    });
  }, [listDevice, order, orderBy]);

  const handleGetDetailVehicle = deviceId => {
    dispatch(getDetailVehicle({ id: deviceId }));
  }

  const handleClickMenu = (event, device) => {
    event.stopPropagation();
    if (device?.id) handleGetDetailVehicle(device.id);

    const rowEl = event.currentTarget.closest('tr') || event.currentTarget;
    setAnchorEl(rowEl);
    setItemCurrent(device);
    setEditOnBar(false);
  };

  const closeModalEdit = () => {
    setOpenEditModal(false);
    setRowsSelected([]);
    setItemCurrent({});
    setSelectedDeviceType(null);
    setSelectedDevicesMap({});
  };

  const closeModalEditVersion = () => {
    setOpenEditVersionModal(false);
    setRowsSelected([]);
    setItemCurrent({});
  };

  const closeModalTransfer = () => {
    setOpenTransferModal(false);
    setRowsSelected([]);
    setItemCurrent({});
  };

  const closeModalTransferSeller = () => {
    setOpenModalSeller(false);
    setRowsSelected([]);
    setItemCurrent({});
  };

  const closeModalActive = () => {
    setOpenModalActive(false);
    setRowsSelected([]);
    setItemCurrent({});
  };

  const closeModalExtend = () => {
    setOpenExtendModal(false);
    setRowsSelected([]);
    setItemCurrent({});
  };

  const closeModalExtendService = () => {
    setOpenExtendServiceModal(false);
    setRowsSelected([]);
    setDevicesToExtend([]);
    setSelectedDeviceType(null);
    setSelectedDevicesMap({});
    setItemCurrent({});
  };

  const handleCloseConfirm = () => {
    setRowsSelected([]);
    setItemCurrent({});
    return dispatch(closeDialogConfirm());
  };
  const checkAll = () => {
    if (rowsSelected.length > 0) {
      setRowsSelected([]);
      setSelectedDeviceType(null);
      setSelectedDevicesMap({});
      setDataChecked({});
    }
    if (listDevice?.length > 0 && rowsSelected.length !== listDevice?.length) {
      const all = listDevice.map(item => item.id);
      setRowsSelected(all);
      // Lưu cả object vào map
      const map = {};
      listDevice.forEach(item => { map[item.id] = item; });
      setSelectedDevicesMap(map);
      setSelectedDeviceType(getDeviceTypeName(listDevice[0]));
      setDataChecked(listDevice[0]);
    }
  };

  const handleEditDevice = () => {
    setOpenEditModal(true);
    handleCloseMenu();
  };

  const handleExtendDevice = (device) => {
    const target = device || itemCurrent;
    setDevicesToExtend([target]);
    setOpenExtendServiceModal(true);
    handleCloseMenu();
  };

  const handleEditVersion = () => {
    setOpenEditVersionModal(true);
    handleCloseMenu();
  };

  const handleTransferDevice = id => {
    setOpenTransferModal(true);
    handleCloseMenu();
  };

  const handleActiveDevice = () => {
    setOpenModalActive(true);
    handleCloseMenu();
  };

  const contentExtend = itemCurrent?.servicePackageExtend?.[0]?.servicePackage
    ?.name
    ? `Bạn có chắc chắn muốn gia hạn gói dịch vụ ${itemCurrent.servicePackageExtend?.[0]?.servicePackage?.name} không ?`
    : 'Vui lòng chọn gói dịch vụ để gia hạn';

  const titleControlSound = itemCurrent?.is_turn_on_sound
    ? 'Tắt âm thanh cảnh báo'
    : 'Bật âm thanh cảnh báo';

  const contentControlSound = itemCurrent?.is_turn_on_sound
    ? `Bạn có chắc chắn muốn tắt âm thanh cảnh báo không ?`
    : `Bạn có chắc chắn muốn bật âm thanh cảnh báo không ?`;



  return (
    <>
      <Snackbar
        open={Boolean(copyToast)}
        autoHideDuration={2000}
        onClose={() => setCopyToast('')}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <MuiAlert
          onClose={() => setCopyToast('')}
          severity="success"
          elevation={6}
          variant="filled"
        >
          {copyToast}
        </MuiAlert>
      </Snackbar>

      <Snackbar
        open={mixedTypeWarning}
        autoHideDuration={3000}
        onClose={() => setMixedTypeWarning(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <MuiAlert
          onClose={() => setMixedTypeWarning(false)}
          severity="warning"
          elevation={6}
          variant="filled"
        >
          Chỉ có thể gia hạn hàng loạt các thiết bị cùng loại!
        </MuiAlert>
      </Snackbar>

      <ModalConfirm
        title={`Thu hồi thiết bị bảo hành`}
        content={`Bạn có chắc chắn muốn thu hồi thiết bị ${recallSerialText} không ?`}
        textOk={'Đồng ý'}
        textCancel={'Hủy'}
        open={openRecallModal}
        setOpen={setOpenRecallModal}
        callbackOk={confirmRecall}
      />

      <ModalConfirm
        title={`Gia hạn gói dịch vụ`}
        content={contentExtend}
        textOk={'Đồng ý'}
        textCancel={'Hủy'}
        open={openExtendModal}
        setOpen={setOpenExtendModal}
        callbackOk={confirmExtendDevices}
      />

      <ModalConfirm
        title={titleControlSound}
        content={contentControlSound}
        textOk={'Đồng ý'}
        textCancel={'Hủy'}
        open={openModalSettingSound}
        setOpen={setOpenModalSettingSound}
        callbackOk={confirmSettingSoundWarn}
      />

      <ModalConfirm
        title={`Dùng Tên/Biển số`}
        content={`Bạn có chắn chắn muốn dùng Tên/biển số không ?`}
        textOk={'Đồng ý'}
        textCancel={'Hủy'}
        open={openSwapLicensePlateModal}
        setOpen={setOpenSwapLicensePlateModal}
        callbackOk={confirmSwap}
      />

      {/* {openExtendModal && (
        <ExtendDevice
          onClose={closeModalExtend}
          open={openExtendModal}
          device={dataSelected}
        />
      )} */}

      {openExtendServiceModal && (
        <ExtendService
          open={openExtendServiceModal}
          device={dataSelected || itemCurrent}
          devices={devicesToExtend.length > 0 ? devicesToExtend : (dataSelected ? [dataSelected] : (itemCurrent ? [itemCurrent] : []))}
          onClose={closeModalExtendService}
        />
      )}

      {openBulkExtendModal && (
        <BulkExtendModal
          open={openBulkExtendModal}
          onClose={() => {
            setOpenBulkExtendModal(false);
            setRowsSelected([]);
            setDevicesToExtend([]);
            setSelectedDeviceType(null);
            setSelectedDevicesMap({});
          }}
          selectedDevices={devicesToExtend}
        />
      )}

      {openWarrantyModal && (
        <WarrantyReplacementModal
          open={openWarrantyModal}
          onClose={() => setOpenWarrantyModal(false)}
          device={warrantyDevice}
          onSuccess={() => {
            getListDeviceRef && getListDeviceRef(currentParams);
          }}
        />
      )}

      {openEditModal && (
        <EditDevice
          open={openEditModal}
          device={dataSelected}
          devices={rowsSelected.length > 0 ? Object.values(selectedDevicesMap) : [dataSelected]}
          onClose={closeModalEdit}
          onSuccess={() => {
            if (getListDeviceRef) {
              getListDeviceRef(currentParams);
            }
          }}
        />
      )}

      {openEditVersionModal && (
        <EditVersion
          open={openEditVersionModal}
          device={dataSelected}
          onClose={closeModalEditVersion}
          fetchDetail={handleGetDetailVehicle}
          onLive4gChanged={() => {
            if (getListDeviceRef) getListDeviceRef(params);
          }}
          onCameraConfigApplied={() => {
            if (getListDeviceRef) getListDeviceRef(params);
          }}
        />
      )}

      {openModalActive && (
        <ActiveDevice
          open={openModalActive}
          onClose={closeModalActive}
          dataSelected={dataSelected}
        />
      )}

      {openTransferModal && (
        <TransferDevice
          open={openTransferModal}
          rowsSelected={
            rowsSelected.length > 0 ? rowsSelected : [itemCurrent.id]
          }
          onClose={closeModalTransfer}
        />
      )}

      {openModalSeller && (
        <TransferSeller
          open={openModalSeller}
          rowsSelected={
            rowsSelected.length > 0 ? rowsSelected : [itemCurrent.id]
          }
          onClose={closeModalTransferSeller}
        />
      )}

      {openDisplayNameModal && (
        <AddDisplayName
          open={openDisplayNameModal}
          device={itemCurrent}
          onClose={() => setOpenDisplayNameModal(false)}
          onSuccess={() => getListDeviceRef(params)}
        />
      )}

      {openChangeLicensePlateModal && (
        <ChangeLicensePlate
          open={openChangeLicensePlateModal}
          device={itemCurrent}
          onClose={() => setOpenChangeLicensePlateModal(false)}
          onSuccess={() => getListDeviceRef(params)}
        />
      )}

      {openWarrantyReplacementModal && (
        <WarrantyReplacementModal
          open={openWarrantyReplacementModal}
          device={itemCurrent}
          onClose={() => setOpenWarrantyReplacementModal(false)}
          onSuccess={() => getListDeviceRef(params)}
        />
      )}

      <DialogConfirm
        title={
          confirmType === 'return_to_stock'
            ? 'Chuyển về lưu kho'
            : MESSAGE.CONFIRM_DELETE_DEVICE
        }
        textOk={MESSAGE.BTN_YES}
        textCancel={MESSAGE.BTN_CANCEL}
        content={
          confirmType === 'return_to_stock'
            ? `Bạn có chắc chắn muốn chuyển thiết bị "${itemCurrent?.serial || ''}" về lưu kho không ?`
            : MESSAGE.CONTENT_DELETE_DEVICE
        }
        callbackOk={() =>
          confirmType === 'return_to_stock'
            ? confirmReturnToStock()
            : confirmDeleteDevices()
        }
        callbackCancel={handleCloseConfirm}
      />

      <TableContainer
        ref={dragScrollRef}
        component={Paper}
        style={{ maxWidth: '100%' }}
        className={classes.root}
      >
        <Box minWidth={1050}>
          {rowsSelected.length > 0 && (
            <Fade in={rowsSelected.length > 0}>
              <Box
                minWidth={1250}
                style={{ fontSize: '14px', padding: '9px 4px' }}
              >
                <span width={50}>
                  <Checkbox
                    checked={rowsSelected.length > 0}
                    onChange={() => checkAll()}
                    color="primary"
                    inputProps={{ 'aria-label': 'secondary checkbox' }}
                  />
                </span>

                <DeviceButtons role={role} row={dataSelected} />
              </Box>
            </Fade>
          )}

          {/* <PerfectScrollbar> */}
          <Box mb={0} className={classes.tableWrapper}>
            <Table>
              {rowsSelected.length === 0 && listDevice?.length > 0 && (
                <TableHead>
                  <TableRow>
                    <TableCell width={50}>
                      <Checkbox
                        checked={rowsSelected.length > 0}
                        onChange={() => checkAll()}
                        color="primary"
                        inputProps={{
                          'aria-label': 'secondary checkbox'
                        }}
                      />
                    </TableCell>
                    <TableCell
                      style={{ width: 50, minWidth: 50, textAlign: 'center' }}
                    >
                      STT
                    </TableCell>
                    {DEVICE_TABLE_HEAD_CELLS.filter(
                      column => column.id !== 'index'
                    ).map(column => (
                      <TableCell
                        key={column.id}
                        sortDirection={orderBy === column.id ? order : false}
                        style={column.style}
                      >
                        {column.sortable === false ? (
                          column.label
                        ) : (
                          <TableSortLabel
                            active={orderBy === column.id}
                            direction={orderBy === column.id ? order : 'asc'}
                            onClick={() => handleRequestSort(column.id)}
                            // Cột căn giữa: bù 26px (= icon sort 18px + margin 2×4px) bên trái để chữ nằm đúng giữa
                            style={
                              column.style?.textAlign === 'center'
                                ? { marginLeft: 26 }
                                : undefined
                            }
                          >
                            {column.label}
                          </TableSortLabel>
                        )}
                      </TableCell>
                    ))}
                    <TableCell style={{ width: 50, minWidth: 50 }}></TableCell>
                  </TableRow>
                </TableHead>
              )}

              <TableBody>
                {sortedDevices.length > 0 ? (
                  sortedDevices.map((device, index) => (
                    <TableRow
                      hover
                      key={device.id}
                      selected={open && itemCurrent?.id === device.id}
                      onMouseDown={e => {
                        rowMouseDownRef.current = { x: e.clientX, y: e.clientY };
                      }}
                      onClick={e => handleRowClick(e, device)}
                      className={classes.clickableRow}
                    >
                      <TableCell onClick={event => event.stopPropagation()}>
                        {(() => {
                          const thisType = getDeviceTypeName(device);
                          const isDifferentType = rowsSelected.length > 0 && selectedDeviceType && thisType && selectedDeviceType !== thisType && !checked(device.id);
                          return (
                            <Tooltip
                              title={isDifferentType ? `Chỉ được chọn thiết bị loại ${selectedDeviceType}` : ''}
                              placement="right"
                            >
                              <span>
                                <Checkbox
                                  checked={checked(device.id)}
                                  onChange={() => select(device.id, device)}
                                  color="primary"
                                  disabled={isDifferentType}
                                  inputProps={{
                                    'aria-label': 'secondary checkbox'
                                  }}
                                  style={isDifferentType ? { opacity: 0.35 } : {}}
                                />
                              </span>
                            </Tooltip>
                          );
                        })()}
                      </TableCell>
                      <TableCell style={{ textAlign: 'center' }}>
                        {(params.page - 1) * params.page_size + index + 1}
                      </TableCell>
                      <TableCell>
                        <CopyableText
                          value={device?.vehicle?.license_plate}
                          label="Biển số"
                          onCopied={handleCopied}
                          classes={classes}
                        />
                      </TableCell>
                      <TableCell>{device?.name || '--'}</TableCell>
                      <TableCell>
                        {device.vehicle?.vehicle_type?.title || '--'}
                      </TableCell>
                      <TableCell>{device?.deviceType?.name || '--'}</TableCell>
                      <TableCell>
                        <CopyableText
                          value={device.serial}
                          label="Serial"
                          onCopied={handleCopied}
                          classes={classes}
                        />
                      </TableCell>
                      <TableCell>{device?.network_operator || '--'}</TableCell>
                      <TableCell>
                        <CopyableText
                          value={device.imei}
                          label="Imei sim"
                          onCopied={handleCopied}
                          classes={classes}
                        />
                      </TableCell>
                      <TableCell>{device?.hardware_version || '--'}</TableCell>
                      <TableCell>{device?.firmware_version || '--'}</TableCell>
                      <TableCell>
                        {getStatusDevice(
                          device?.status,
                          device?.deviceServicePackages?.remaining_days
                        )}
                      </TableCell>
                      <TableCell align="center">
                        <Box display="flex" justifyContent="center" alignItems="center">
                          {CAMERA_DEVICE_TYPES.includes(device?.deviceType?.name) ? (
                            <Tooltip title={isLive4gOn(device) ? 'Đang bật' : 'Đang tắt'}>
                              <span
                                onClick={event => event.stopPropagation()}
                                style={{ display: 'inline-flex' }}
                              >
                                <CustomSwitchWithText
                                  checked={isLive4gOn(device)}
                                  onChange={() => { }}
                                  inputProps={{ 'aria-label': 'Live 4G', readOnly: true }}
                                  style={{ pointerEvents: 'none' }}
                                />
                              </span>
                            </Tooltip>
                          ) : (
                            '--'
                          )}
                        </Box>
                      </TableCell>
                      <TableCell>
                        {device.active_at
                          ? moment(device.active_at).format(
                            'HH:mm:ss DD-MM-yyyy'
                          )
                          : '--'}
                      </TableCell>
                      <TableCell>
                        {device.deviceServicePackages?.servicePackage?.name ||
                          '--'}
                      </TableCell>
                      <TableCell>
                        {getAccStatusText(device)}
                      </TableCell>
                      <TableCell>
                        {device.battery || '--'}
                      </TableCell>
                      <TableCell>
                        {getSlotsOrTonnage(
                          device.vehicle?.vehicle_type?.title,
                          device
                        )}
                      </TableCell>
                      <TableCell>
                        {getOilStatusText(device)}
                      </TableCell>
                      <TableCell style={{ textAlign: 'center' }}>
                        {device?.deviceType?.name === 'VGPS_CAR4G'
                          ? getTransmissionStatusText(device?.status_transmission)
                          : '--'}
                      </TableCell>
                      <TableCell>
                        {getRemainingDays(device?.subscription?.end) ||
                          '--'}
                      </TableCell>
                      <TableCell>
                        <RenderListExtendPackages
                          listPackages={device?.servicePackageExtend}
                          classes={classes}
                        />
                      </TableCell>
                      <TableCell>
                        {device?.date_of_manufacture
                          ? moment(device.date_of_manufacture).format(
                            'DD-MM-yyyy'
                          )
                          : '-'}
                      </TableCell>
                      <TableCell>
                        {device.end_user?.user?.full_name || '--'}
                      </TableCell>
                      <TableCell>
                        <CopyableText
                          value={device.end_user?.user?.phone}
                          label="Số điện thoại"
                          onCopied={handleCopied}
                          classes={classes}
                        />
                      </TableCell>
                      <TableCell>
                        <Tooltip title={device.agency?.name || '--'}>
                          <span>
                            {truncateText(device.agency?.name || '--', 30)}
                          </span>
                        </Tooltip>{' '}
                        {device.agency?.agency_code && (
                          <Tooltip title={`(${device.agency.agency_code})`}>
                            <span>
                              {truncateText(
                                `(${device.agency.agency_code})`,
                                15
                              )}
                            </span>
                          </Tooltip>
                        )}
                      </TableCell>
                      <TableCell>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <Box
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                      width: '100vw'
                    }}
                  >
                    <Box>
                      <img
                        src="/static/empty.png"
                        class="justify-content-center"
                      />
                    </Box>
                    <Typography>
                      <h5>
                        {isCustomerCare && !currentParams?.keywords
                          ? 'Vui lòng nhập serial hoặc biển số xe để tìm kiếm'
                          : 'Danh sách trống'}
                      </h5>
                    </Typography>
                  </Box>
                )}
              </TableBody>
            </Table>

            <Popover
              id={`menu-device-${itemCurrent.id}`}
              className="popover-device"
              PaperProps={{ className: classes.actionMenuPaper }}
              open={Boolean(anchorEl)}
              anchorEl={anchorEl}
              onClose={handleCloseMenu}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right'
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right'
              }}
            >
              <DeviceMenu role={role} device={itemCurrent} />
            </Popover>
          </Box>
          {/* </PerfectScrollbar> */}
        </Box>
        {/* </Card> */}
      </TableContainer>
      {listDevice && listDevice.length > 0 && (
        <div class="mt-3 mr-4 float-right">
          <Box
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '15px'
            }}
          >
            <Typography style={{ fontSize: '14px' }}>
              Tổng: {totalDevice}
            </Typography>
            <Pagination
              count={Math.ceil(totalDevice / limit)}
              color="primary"
              size="small"
              onChange={handlePageChange}
              page={Number(params.page) || 1}
              siblingCount={isMobile ? 0 : 1}
              boundaryCount={isMobile ? 1 : 2}
              showFirstButton={!isMobile}
              showLastButton={!isMobile}
            />
          </Box>
        </div>
      )}
    </>
  );
};

Results.propTypes = {
  className: PropTypes.string,
  listDevice: PropTypes.array.isRequired,
  currentParams: PropTypes.object
};

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    overflowX: 'auto',
    '&.MuiPaper-elevation1': {
      boxShadow: 'none'
    },
    '&::-webkit-scrollbar': {
      width: '8px',
      height: '8px'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#d2d9ddff',
      borderRadius: '8px'
    },
    '&::-webkit-scrollbar-thumb:hover': {
      backgroundColor: '#bfc6caff'
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: '#f1f1f1',
      borderRadius: '8px'
    }
  },
  actionMenuPaper: {
    backgroundColor: '#f5f7fa',
    border: '1px solid #e1e5eb',
    borderRadius: '8px',
    boxShadow: '0 6px 16px rgba(0, 0, 0, 0.12) !important',
    '& .list-menu-device': {
      padding: '10px 16px'
    },
    '& .list-menu-device:hover': {
      backgroundColor: '#e8ecf2'
    }
  },
  popover: {
    pointerEvents: 'none'
  },
  paper: {
    padding: theme.spacing(1)
  },
  tableWrapper: {
    '& .MuiTableCell-root': {
      borderBottom: '2px solid #F1F1F1 !important',
      padding: '4px !important',
      whiteSpace: 'nowrap'
    }
  },
  clickableRow: {
    cursor: 'pointer'
  },
  copyIcon: {
    fontSize: 14,
    marginLeft: 6,
    cursor: 'pointer',
    color: '#AEB1C5',
    '&:hover': {
      color: '#D9042F'
    }
  }
}));

export default React.memo(Results);
